import { createAsyncThunk } from "@reduxjs/toolkit";
import { typedAdminAPI } from '../api/typedApi';
import { toast } from "react-toastify";

export const createUser = createAsyncThunk(
  'createUser/admin', async (userData: any, { rejectWithValue }) => {
    try {
      const response = await typedAdminAPI.createUser(userData);
      toast.success("User created successfully");
      return response.data;
    } catch (error: any) {
      toast.error(error.response.data.title ?? "Something went wrong")
    }
  }
)
